// src/components/ChatHeader.tsx
import React from 'react';
import AILogo from 'assets/icons/ai-logo.svg';
import { TrashCanSolidIcon } from 'assets/icons';
import QBOConnectionButton from 'Components/Quickbooks/QuickbooksButton'; // Adjust the path as needed
import DeleteButton from 'Components/Buttons/DeleteButton';
interface ChatHeaderProps {
  onReset: () => void; // Reset function for chat
}

const ChatHeader: React.FC<ChatHeaderProps> = ({ onReset }) => {
  return (
    <div className="chat-header flex items-center justify-between px-4 py-2 border-b border-gray-200">
      <div className="flex items-center">
        <img src={AILogo} alt="AI Logo" className="w-8 h-8" />
        <h2 className="ml-2 text-md font-semibold">Mito AI</h2>
      </div>
      <div className="flex items-center">
        <QBOConnectionButton />
        <button
          className="ml-4 p-2 bg-red-50 text-red-600 rounded"
          onClick={onReset}
          title="Delete Chat"
        >
          <TrashCanSolidIcon className="w-5 h-5" />
        </button>
      </div>
    </div>
  );
};

export default ChatHeader;
